/* unplugin-vue-components disabled */import script from "./CorporateInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./CorporateInformation.vue?vue&type=script&setup=true&lang=ts"

import "./CorporateInformation.vue?vue&type=style&index=0&id=12e88de4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e88de4"]])

export default __exports__